<div class="main-container">
    <div
        [ngClass]="
            styleType === 'rounded'
                ? 'tv-round-input-extensible-no-label-no-border'
                : showFloatLabel
                ? 'tv-square-input-for-date-pickers-with-label'
                : 'tv-square-input-for-date-pickers-no-label'
        ">
        <mat-form-field class="tv-date-range-picker">
            <mat-label>Période</mat-label>
            <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-input
                [formGroup]="dateRangeForm"
                [rangePicker]="picker"
                [min]="isRestrictedToParamDates ? minDate : null"
                [max]="resolvedMaxDate">
                <input matStartDate formControlName="startDate" />
                <input matEndDate formControlName="endDate" />
            </mat-date-range-input>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <div class="tv-input-error-message" *ngIf="dateRangeError">
            <mat-icon class="tv-input-error-icon">error</mat-icon>
            <span class="tv-input-error-text">Veuillez renseigner une période</span>
        </div>
    </div>
</div>
